const earningLineChart = {
    series: [{
        name: 'series1',
        data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76]
    }],
    chartOptions: {
        chart: {
            height: 320,
            type: 'line',
            toolbar: 'false',
            dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 7,
                blur: 8,
                opacity: 0.2
            },
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#556ee6'],
        stroke: {
            curve: 'smooth',
            width: 3,
        },
    }
};

const top10virus = {
    series: [21, 18, 14, 13, 10, 8, 6, 5, 4, 1],
    chartOptions: {
        stroke:{
            colors:['#e5e5e5']
        },
        legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            horizontalAlign: 'center', 
            floating: false,
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: undefined,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 0,
            labels: {
                colors: '#fff',
                useSeriesColors: false
            },
            markers: {
                width: 12,
                height: 12,
                strokeWidth: 0,
                strokeColor: '#fff',
                fillColors: undefined,
                radius: 12,
                customHTML: undefined,
                onClick: undefined,
                offsetX: 0,
                offsetY: 0
            },
            itemMargin: {
                horizontal: 5,
                vertical: 4
            },
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: true
            },
        },
        chart: {
            type: 'pie',
        },
        labels: ['CryptoLoc', 'PlugX', 'Zeus Gameover','Stuxnet', 'MyDoom', 'Sasser and Netsky','Code Red', 'Nimba', 'ILOVEYOU', 'Melissa'],
        colors: ["#78350f", "#92400e", "#b45309", "#d97706", "#f59e0b", "#fbbf24", "#fcd34d", "#fde68a", "#fef3c7", "#fffbeb"],
     
        plotOptions: {
            pie: {
                donut: {
                    size: '60%',
                }
            }
        }
    }
};

const reportStatistics = {
    series: [ {
            name: "Validate",
            data: [4, 5, 7, 8, 5, 3, 5, 7, 5, 4, 5, 5, 2, 2, 2, 2, 1, 7, 7, 4, 6, 3, 1, 4, 1, 3, 4, 2, 7, 2]
        },
        {
            name: "Pending",
            data: [2, 3, 5, 2, 2, 4, 2, 3, 6, 4, 3, 4, 5, 2, 1, 1, 2, 2, 2, 1, 2, 2, 3, 1, 1, 3, 3, 2, 2, 1]
        },
        {
            name: "Not Valid",
            data: [1, 0, 2, 2, 2, 2, 3, 1, 2, 1, 2, 3, 3, 1, 0, 4, 3, 1, 3, 2, 1, 0, 2, 2, 1, 4, 2, 1, 2, 2]
        }
    ],
    chartOptions: {
        legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            horizontalAlign: 'center', 
            floating: false,
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: undefined,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 0,
            labels: {
                colors: '#fff',
                useSeriesColors: false
            },
            markers: {
                width: 12,
                height: 12,
                strokeWidth: 0,
                strokeColor: '#fff',
                fillColors: undefined,
                radius: 12,
                customHTML: undefined,
                onClick: undefined,
                offsetX: 0,
                offsetY: 0
            },
            itemMargin: {
                horizontal: 5,
                vertical: 4
            },
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: true
            },
        },
        chart: {
            type: "line",
            stacked: false,
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false,
            }
        },
        colors: ['#009688', '#53A9DA', '#E7515A'],
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: [2, 2, 2],
        },
        title: {
            text: 'Daily Comulative Report',
            align: 'left'
        },
        markers: {
            size: 0,

            hover: {
                sizeOffset: 6
            }
        },
        xaxis: {
            categories: ['01 Des', '02 Des', '03 Des', '04 Des', '05 Des', '06 Des', '07 Des', '08 Des', '09 Des','10 Des', '11 Des', 
            '12 Des','13 Des', '14 Des', '15 Des', '16 Des', '17 Des', '18 Des', '19 Des', '20 Des', '21 Des','22 Des', '23 Des', 
            '24 Des','25 Des', '26 Des', '27 Des','28 Des', '29 Des', '30 Des',
            ],
        },
        tooltip: {
            y: [{
                title: {
                    formatter: function (val) {
                        return val + " (mins)"
                    }
                }
            }, {
                title: {
                    formatter: function (val) {
                        return val + " per session"
                    }
                }
            }, {
                title: {
                    formatter: function (val) {
                        return val;
                    }
                }
            }]
        },
        grid: {  
            show: true,
            strokeDashArray: 0.3,
            borderColor: "#000",    // you can either change hear to disable all grids
            xaxis: {
                lines: {
                show: false  //or just here to disable only x axis grids
                }
                },  
            yaxis: {
                lines: { 
                show: true  //or just here to disable only y axis
                }
            }, 
        } 
    }
};

const malwareTypesDonutChart = {
    series: [20, 15, 5],
    chartOptions: {
        chart: {
            type: 'donut',
            height: 240,
        },
        labels: ['Known', 'Unknown ','Not Malware'],
        colors: ['#556ee6', '#34c38f', '#f46a6a','#f59e0b'],
        legend: {
            show: false,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '60%',
                }
            }
        }
    }
};

const ChatData = [
    {
        id: 1,
        name: 'Steven Franklin',
        message: 'Hello!',
        time: '10:00',
    },
    {
        id: 2,
        align: 'right',
        name: 'Henry Wells',
        message: 'Hi, How are you? What about our next meeting?',
        time: '10:02'
    },
    {
        id: 3,
        name: 'Steven Franklin',
        message: 'Yeah everything is fine',
        time: '10:06'
    },
    {
        id: 4,
        name: 'Steven Franklin',
        message: '& Next meeting tomorrow 10.00AM',
        time: '10:06'
    },
    {
        id: 5,
        align: 'right',
        name: 'Henry Wells',
        message: "Wow that's great",
        time: '10:02'
    },
]

const malwareRecapitulation = {
    series: [{
        name: 'Commonly Used Office File Extension (.ppt, .doc, etc)',
        data: [34, 40, 28, 52, 42, 109, 100, 34, 52, 41, 100, 34, 52, 41]
    }, {
        name: 'Archives, Media Files (.zip, .rar, .tar, etc)',
        data: [10, 20, 34, 20, 30, 40, 25, 34, 52, 41, 140, 34, 75, 41]
    }, {
        name: 'Encryption Keys and Certificates (.key, .pfx, etc)',
        data: [5, 10, 20, 40, 30, 50, 40, 34, 25, 41, 50, 34, 20, 10]
    }, {
        name: 'Database Files (.sql, .accdb, .mdb, etc)',
        data: [32, 60, 34, 46, 34, 52, 41, 34, 52, 41, 60, 50, 52, 21]
    }, {
        name: 'Other Format',
        data: [20, 40, 30, 40, 34, 52, 41, 34, 52, 41, 50, 34, 40, 41]
    }

],
    chartOptions: {
        legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'right',
            horizontalAlign: 'center', 
            floating: false,
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: undefined,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 0,
            labels: {
                colors: '#fff',
                useSeriesColors: false
            },
            markers: {
                width: 12,
                height: 12,
                strokeWidth: 0,
                strokeColor: '#fff',
                fillColors: undefined,
                radius: 12,
                customHTML: undefined,
                onClick: undefined,
                offsetX: 0,
                offsetY: 0
            },
            itemMargin: {
                horizontal: 5,
                vertical: 4
            },
            onItemClick: {
                toggleDataSeries: true
            },
            onItemHover: {
                highlightDataSeries: true
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: [0,0,0],
        },
        colors: ['#0c4a6e','#0369a1', '#0284c7','#0ea5e9','#38bdf8','#7dd3fc','#bae6fd'],
        xaxis: {
            type: 'text',
            categories: ["07/12/2022", "08/12/2022", "09/12/2022", "10/12/2022", "11/12/2022", "12/12/2022", "13/12/2022", "14/12/2022", "15/12/2022", "16/12/2022", "17/12/2022", "18/12/2022", "19/12/2022","Today"],
        },
        grid: {  
            show: true,
            strokeDashArray: 0.3,
            borderColor: "#000",    // you can either change hear to disable all grids
            xaxis: {
                lines: {
                show: false  //or just here to disable only x axis grids
                }
                },  
            yaxis: {
                lines: { 
                show: true  //or just here to disable only y axis
                }
            }, 
        }
    }
};

export { malwareRecapitulation, earningLineChart, top10virus, ChatData, malwareTypesDonutChart, reportStatistics };
